import Cookies from 'js-cookie';

export const isLocalhost = () => {
    try {
        return (
            typeof window !== 'undefined' &&
            window.location.hostname === 'localhost'
        );
    } catch {
        return false;
    }
};

export const getDomainOrigin = () => {
    try {
        if (window !== undefined) {
            if (window.location.hostname === 'localhost') {
                return 'http://localhost:7000';
            }
            return window.location.origin;
        }
        return 'https://www.acko.com';
    } catch (e) {
        console.error('domain error ', e);
        return 'https://www.acko.com';
    }
};

export const getServerHostDomain = (host?: string) => {
    try {
        if (host?.includes('localhost')) {
            return 'http://localhost:7000';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'tronix') {
            return 'https://tronix.acko.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'master') {
            return 'https://www.ackodev.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'isnp') {
            return 'https://acko-isnp.ackodev.com';
        }
        return 'https://www.acko.com';
    } catch {
        return 'https://www.acko.com';
    }
};

export function getHeaders() {
    return {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'x-a-k': Cookies.get('x-a-k'),
        'x-a-t': Cookies.get('x-a-t'),
        'x-r-t': Cookies.get('x-r-t'),
    };
}

// Returns axios config for local proxy support (withCredentials for localhost)
export function getAxiosConfig() {
    return {
        headers: getHeaders(),
        withCredentials: isLocalhost(),
    };
}
